import { extractShortName, formatRouteLabel } from '@/services/route-labels';
import '@/screens/LiveMapScreen.css';

export const VEHICLE_MODE_COLORS: Record<string, string> = {
  Train: '#F6891F', Bus: '#0072C6', Ferry: '#61B255', Metro: '#0099CD', 'Light Rail': '#D81E34',
};

/** Realtime's bus feed also carries the 80L2/80L3 light-rail services. */
export function vehicleModeForRoute(mode: string, route: string | undefined): string {
  const short = extractShortName(route) || '';
  return mode === 'Bus' && /^L\d/.test(short) ? 'Light Rail' : mode;
}

export function vehicleRouteNumber(mode: string, route: string | undefined): string {
  const raw = route?.trim().toLocaleUpperCase() || '';
  const short = extractShortName(route) || '';
  if (mode === 'Light Rail') return raw.match(/L\d+/)?.[0] || short.match(/L\d+/)?.[0] || 'L';
  if (mode === 'Ferry') return raw.match(/F\d+/)?.[0] || short.match(/F\d+/)?.[0] || 'F';
  if (mode === 'Metro') return raw.match(/M\d+/)?.[0] || short.match(/M\d+/)?.[0] || 'M';
  if (mode === 'Train') {
    // extractShortName already maps opaque GTFS prefixes (NSN→T1, WST→T1,
    // APS→T8, OLY→T7, CMB→T5, NTH→T9, ESI→T4, IWL→T2, BMT→T1) to public codes.
    if (short) return short;
    return 'T';
  }
  return short.match(/^[A-Z0-9]{1,4}$/)?.[0] || mode.slice(0, 1).toUpperCase();
}

export function vehicleDisplayLabel(mode: string, route: string | undefined, destination?: string): string {
  // Normalize opaque realtime ids before formatting the popup/accessible
  // label. This keeps markers compact (L2/F8/T9) while retaining the full
  // destination text when it is available.
  const short = extractShortName(route);
  return formatRouteLabel(mode, short || route, destination);
}

export function VehicleMarker({ mode, route, destination, title, bearing, onClick }: { mode: string; route?: string; destination?: string; title?: string; bearing?: number; onClick?: () => void }) {
  const label = vehicleRouteNumber(mode, route);
  return (
    <div
      className="vehicle-marker"
      style={{ background: VEHICLE_MODE_COLORS[mode] || '#666' }}
      title={title || vehicleDisplayLabel(mode, route, destination)}
      aria-label={vehicleDisplayLabel(mode, route, destination)}
      onClick={onClick ? (event) => { event.stopPropagation(); onClick(); } : undefined}
    >
      {Number.isFinite(bearing) && <span className="vehicle-marker-direction" style={{ transform: `translateX(-50%) rotate(${bearing}deg)` }} aria-hidden="true">▲</span>}
      <span className="vehicle-marker-label">{label}</span>
    </div>
  );
}
